import StarRating from 'star-rating.js/src/index';

export function RatingSelect(element: HTMLElement) {
    return new StarRating(element, {
        tooltip: 'Bewerten',
        clearable: true,
    });
}

document.querySelectorAll('.star-rating').forEach((element: HTMLElement) => {
    RatingSelect(element);
});
